import OmnitecTab from './OmnitecTab'

export default OmnitecTab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/index.js